import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { messagesResponse } from '@appTypes/messageType';
import { Actions, actions } from '@redux/modules/myMessages';
import { TypedEpic } from './types';

export const getMyMessagesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_MESSAGES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getMyMessages.request>[]
    >,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<messagesResponse>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].messages,
        }),
      ).pipe(
        map((response) => actions.getMyMessages.success(response.data)),
        catchError((err) =>
          of(
            actions.getMyMessages.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente meldingene dine! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [getMyMessagesEpic];
